<template>
    <el-form ref="form" label-position="top" v-loading="getScreenSize < 2 && !delayedLoading[5]"  element-loading-text="Loading...">
        <el-form-item class="el-form-item-full" v-if="getScreenSize > 1 || delayedLoading[0]" :label="$l('settings/download/Compression')">
            <el-select v-model="getUnsavedLocalSettings.download.downlzip" :placeholder="$l('common/select')">
                <el-option :label="$l('settings/download/No compression')" :value="parseInt(0)"></el-option>
                <el-option :label="$l('settings/download/Zip compression')" :value="parseInt(1)"></el-option>
            </el-select>
        </el-form-item>
        <el-collapse accordion>
            <el-collapse-item v-if="getScreenSize > 1 || delayedLoading[1]" :class="getClass('noise')" :title="$l('settings/download/Noise')">
                <el-row> <!-- Podatke treba spremenit v TABELO!   "nan,SPLAF,LAeqF,LAMaxF,LCeqF,fLeqF" -->
                    <el-col v-for="value in getSettingsDevice.valsel" v-bind:key="value" :sm="6" :lg="4">
                        <el-form-item class="el-form-item-full" :label="value">
                            <el-switch on-text="" off-text="" off-value=""  v-model="getUnsavedLocalSettings.download.downlnoise[value]"></el-switch> 
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item v-if="getScreenSize > 1 || delayedLoading[2]" :class="getClass('weather')" :title="$l('settings/download/Weather')">
                <el-row>
                    <el-col v-for="item in getSettingsWeather.valsel" v-bind:key="item.name" v-if="item.enabled" :sm="12" :lg="8"><el-form-item class="el-form-item-full" :label="item.name"><el-switch on-text="" off-text="" v-model="getUnsavedLocalSettings.download.downlweath[item.name]"></el-switch></el-form-item></el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item v-if="getScreenSize > 1 || delayedLoading[3]" :class="getClass('noise')" :title="$l('settings/download/Global Values')">
                <el-row>
                    <el-col v-for="item in getSettingsSpecval.global" v-bind:key="item" :sm="6" :lg="4"><el-form-item class="el-form-item-full" :label="item"> <el-switch on-text="" off-text=""  v-model="getUnsavedLocalSettings.download.downlGlobal[item]"></el-switch> </el-form-item></el-col>
                     </el-row>
            </el-collapse-item>
            <el-collapse-item v-if="getScreenSize > 1 || delayedLoading[4]" :title="$l('settings/download/Special values')">
                <el-row>
                    <el-col :sm="6" :lg="4">
                        <el-form-item class="el-form-item-full" :label="$l('settings/download/Audio')">
                            <el-switch on-text="" off-text=""  v-model="getUnsavedLocalSettings.download.audio"></el-switch> 
                        </el-form-item>
                    </el-col>
                    <el-col :sm="6" :lg="4">
                        <el-form-item class="el-form-item-full" :label="$l('settings/download/Video')">
                            <el-switch on-text="" off-text=""  v-model="getUnsavedLocalSettings.download.video"></el-switch> 
                        </el-form-item>
                    </el-col>
                    <el-col :sm="6" :lg="4">
                        <el-form-item class="el-form-item-full" :label="$l('settings/download/Markers')">
                            <el-switch on-text="" off-text=""  v-model="getUnsavedLocalSettings.download.markers"></el-switch> 
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>
        </el-collapse>
    </el-form>
</template>

<style>
    .disabled-button .el-collapse-item__header{
        cursor: not-allowed !important;
    }
    .disabled-button .el-collapse-item__wrap{
        display: none;
    }
/*.el-collapse-item__header{
    height:25px;
    line-height:25px;
    text-align:left;
}*/
</style>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            delayedLoading:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0}

        }
    },
    computed:{
        ...mapGetters([
            'getSettingsDownload',
            'getSettingsDevice',
            'getSettingsWeather',
            'getUnsavedLocalSettings',
            'getSettingsSpecval',
            'getSettingsAddons',
            'getScreenSize',
        ]),
    },
    methods:{
        getClass:function(menu){
            if(this.getSettingsAddons[menu]=='0') return 'disabled-button';
            return '';
        },
    },
    mounted: function(){
        setTimeout(()=>{
            var counter = 0;
            var delayedLoadingInterval = setInterval(()=>{
                this.delayedLoading[counter] = true;
                counter++;
                if(counter > 5) 
                    clearInterval(delayedLoadingInterval);
            },0);
        },500)
    }
}
</script>


// WEBPACK FOOTER //
// Download.vue?63042e96